<!-- 店铺 -->
<template>
  <div>
    <div class="head-title">全部门店</div>
    <nav class="navbar">
      <div class="nav-l">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          :loading="updateLoading"
          @click="getRenew"
          >更新门店</el-button
        >
      </div>
      <div class="nav-r">
        <el-input
          clearable
          style="width: 35.0rem; margin: 0 .0rem 0 2.0rem"
          placeholder="请输入门店名称"
          prefix-icon="el-icon-search"
          v-model="q"
          @change="getList()"
        >
        <el-button slot="append" type="primary" @click="getList()"
          >查询</el-button
        >
        </el-input>
        
      </div>
    </nav>
    <div class="main">
      <el-table
        :data="tableData"
        border
        header-align="center"
        align="center"
      >
        <el-table-column prop="storeNumber" label="门店编号"></el-table-column>
        <el-table-column prop="title" label="门店信息" min-width="320">
          <template slot-scope="scope">
            <div class="scope-title">
              <el-image
                class="scope-title-img"
                style="width: 36px; height: 36px"
                :src="scope.row.storeLogoUrl"
                :preview-src-list="[scope.row.storeLogoUrl]"
              ></el-image>
              <p class="scope-title-text" :title="scope.row.storeName">
                {{ scope.row.storeName }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="isHeadStore" label="是否总店" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.isHeadStore == 0">否</div>
            <div v-else>是</div>
          </template>
        </el-table-column>
        <el-table-column prop="onlineStatus" label="网店设置" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.isHeadStore == 0">停用</div>
            <div v-else>启用</div>
          </template>
        </el-table-column>
        <el-table-column prop="storeStatus" label="门店状态" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.isHeadStore == 1">启用</div>
            <div v-else-if="scope.row.isHeadStore == 2">已删除</div>
            <div v-else-if="scope.row.isHeadStore == 0">停用</div>
          </template>
        </el-table-column>
        <el-table-column prop="storeTel" label="联系电话" min-width="140">
        </el-table-column>
        <el-table-column
          prop="address"
          label="门店地址"
          min-width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column width="160" prop="createtime" label="创建时间">
        </el-table-column>
      </el-table>
      <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "./mixins/wm.js";
export default {
  name: "storeList",
  components: {},
  mixins: [auth],
  data() {
    return {
      q: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      updateLoading: false,
    };
  },
  beforeRouteLeave(to,from,next){
    let arr = ['storelist','selfList','goodsList','orderlist','customerlist']
    if(!arr.includes(to.name)){
      this.$store.state.enterWeimeng=false
    }
    next()
  },
  computed: {},

  mounted() {
    this.getList();
  },
  methods: {
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新历史朋友圈数据
      const { data: res } = await this.axios({
        url: "weimob/merchant/Store/queryStoreList",
        method: "POST",
        data: this.qs.stringify({
          phone: this.tooken.phone,
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
        }),
      });
      this.updateLoading = false;
      this.tableData = [];
      this.getList();
    },
    async getList() {
      const { data: res } = await this.axios({
        url: "weimob/merchant/Store/getStoreList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
          storeName: this.q,
        }),
      });
      console.log(res);
      if (res.code == 1) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    onRead() {},
  },
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 3.0rem;
}
.scope-title {
  display: flex;
  &-img {
    width: 36px;
  }
  &-text {
    flex: 1;
    margin-left: 8px;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    cursor: pointer;
  }
}

.sales-status {
  display: flex;
  align-items: center;
}
</style>
